class LanguagesHelper {
  getOptions () {
    return [
      {
        value: '2',
        text: 'נמוכה'
      },
      {
        value: '4',
        text: 'בינונית'
      },
      {
        value: '6',
        text: 'גבוהה'
      },
      {
        value: '7',
        text: 'כשפת אם'
      },
      {
        value: '8',
        text: 'שפת אם'
      }
    ].reverse()
  }

  getTextByValue (value) {
    if (value == '2') {
      return 'נמוכה'
    }
    if (value == '4') {
      return 'בינונית'
    }
    if (value == '6') {
      return 'גבוהה'
    }
    if (value == '7') {
      return 'כשפת אם'
    }
    if (value == '8') {
      return 'שפת אם'
    }
  }
}

export default LanguagesHelper
